<template>
  <div>
    <CancelRecurrenceConfirmation
      v-if="!confirmed"
      @confirm="confirmed = true"
    />
    <CancelRecurrenceConfirmed v-else />
  </div>
</template>

<script>
import CancelRecurrenceConfirmation from './CancelRecurrenceConfirmation';
import CancelRecurrenceConfirmed from './CancelRecurrenceConfirmed';

export default {
  name: 'CancelRecurrence',
  components: { CancelRecurrenceConfirmation, CancelRecurrenceConfirmed },
  data() {
    return {
      confirmed: false
    };
  }
};
</script>
